<template>
  <div class="feed_container">
    <n-popover trigger="hover">
      <template #trigger>
        <img src="@/assets/feedback.png" alt="" class="feedback-img" @click="feedbackModalShow" />
      </template>
      <span>Feedback</span>
    </n-popover>
    <feedback-modal v-model:feedbackShowModal="feedbackShowModal"></feedback-modal>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import FeedbackModal from '@/components/FeedbackModal.vue';

const feedbackShowModal = ref(false);
const feedbackModalShow = () => {
  feedbackShowModal.value = true;
};
</script>

<style lang="scss" scoped>
.feed_container {
  position: fixed;
  right: 24px;
  bottom: 129px;
  z-index: 10;
  .feedback-img {
    width: 60px;
    cursor: pointer;
  }
}

.feedback_svg {
  font-size: 24px;
}

.feed_container_circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(224, 224, 230);

  &:hover {
    // border
    border-color: #170e67;
  }
}
</style>
